var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-auth"},[_c('svg',{staticClass:"the-auth__logo",attrs:{"width":"280","height":"54"}},[_c('use',{attrs:{"xlink:href":"#icon-logo"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }